<template>
    <div>
        <form ref="form" @submit.prevent>
            <!-- <topSearch></topSearch> -->
            <!-- <breadcrumb></breadcrumb> -->

            <div class="top-title-content">
                <span class="title">센터관리</span>
                <span class="txt">센터의 이름, 주소, 전화번호 등 센터의 기본정보를 설정합니다.</span>
            </div>

            <div class="com-table-top">
                <div class="logo-area">
                    <div class="logo-box">
                        <span class="logo">
                            <img :src="centerData.logoUrl" alt="" />
                        </span>
                    </div>
                    <div class="info-box">
                        <span class="location">{{ centerData.centerName }}</span>
                        <span class="address">
                            {{ centerData.address }} {{ centerData.addressDetail }} /
                            {{ `${centerData.telNo1 || ''}-${centerData.telNo2 || ''}-${centerData.telNo3 || ''}` }}
                        </span>
                        <span v-if="centerData.centerType == 'M'" class="type">본사</span>
                        <span v-else class="type">지점</span>
                    </div>
                </div>
            </div>

            <div class="com-tab">
                <span v-for="(item, index) in submenus" :key="index">
                    <router-link :class="{ on: $route.name == item.name }" :to="{ ...item, params: { centerId } }">
                        {{ item.label }}
                    </router-link>
                </span>
            </div>

            <div class="center-fitpay">
                <div v-if="!fitpayList.length && !editData" class="fitpay-starter">
                    <template v-if="!isLoading">
                        <div class="desc">
                            원하는 결제 방식으로 언제 어디서든 쉽고 빠르게 비대면 결제, 핏페이 서비스
                            <br />
                            카드사 상관없이 무이자 3개월 할부 + 업계 최저 카드 수수료 1.2% 등 지금 핏페이를 신청하고
                            다양한 혜택을 받아보세요!
                        </div>
                        <div class="avatar"></div>
                        <button class="com-btn blue" @click="handleAddNew">핏페이 신청하기</button>
                    </template>
                </div>
                <div v-else-if="!!editData" class="fitpay-detail">
                    <p class="tit">핏페이 신청</p>
                    <div class="guide">
                        <div class="flex-fill">
                            <p class="g_tit">핏페이가 처음이신가요?</p>
                            <p>
                                핏페이는 문자, 카카오톡으로 URL을 전송하여 언제 어디서나 비대면 간편결제가 가능한 온라인
                                결제 서비스입니다.
                                <br />
                                업계 최저 수수료, 카드사 상관없이 3개월 무이자 할부 등 핏페이의 다양한 혜택을
                                경험해보세요!
                            </p>
                        </div>
                        <button class="com-btn blue">+ 핏페이 알아보기</button>
                    </div>
                    <div class="com-table-wrap mt-4">
                        <div class="info-edit-table">
                            <table>
                                <colgroup>
                                    <col style="width: 160px" />
                                    <col style="width: 560px" />
                                    <col style="width: auto" />
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th>
                                            정산 담당자
                                            <span class="imp">*</span>
                                        </th>
                                        <td colspan="2">
                                            <select-form
                                                :select-data="['담당자 선택', ...Object.values(staffs)]"
                                                :select-value="['', ...Object.keys(staffs)]"
                                                :selected-value.sync="editData.centerStaffId"
                                                @update:set="handleChangeStaff"
                                            ></select-form>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            담당자 연락처
                                            <span class="imp">*</span>
                                        </th>
                                        <td colspan="2">
                                            <div class="com-tel">
                                                <input
                                                    v-model="editData.telNo1"
                                                    type="text"
                                                    maxlength="3"
                                                    placeholder="010"
                                                />
                                                <!-- validation 필수값 여부 제거(21.03.17) -->
                                                <span class="bar">-</span>
                                                <input
                                                    v-model="editData.telNo2"
                                                    required
                                                    type="text"
                                                    maxlength="4"
                                                    placeholder="0000"
                                                />
                                                <span class="bar">-</span>
                                                <input
                                                    v-model="editData.telNo3"
                                                    required
                                                    type="text"
                                                    maxlength="4"
                                                    placeholder="0000"
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            담당자 이메일
                                            <span class="imp">*</span>
                                        </th>
                                        <td colspan="2">
                                            <div class="com-email">
                                                <input v-model.trim="editData.email1" class="first" type="text" />
                                                <span class="txt">@</span>
                                                <input
                                                    v-model.trim="editData.email2"
                                                    class="last"
                                                    type="text"
                                                    :disabled="!!editData.emailType"
                                                />
                                                <select-form
                                                    :select-data="['직접 입력', ...emailTypeValueList]"
                                                    :select-value="['', ...emailTypeValueList]"
                                                    :selected-value.sync="editData.emailType"
                                                    @update:set="(val) => onChangeEmail(val)"
                                                ></select-form>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            정산 계좌
                                            <span class="imp">*</span>
                                        </th>
                                        <td colspan="2">
                                            <div class="d-flex align-items-center gap-2">
                                                <select-form
                                                    :select-data="['은행 선택', '직접 입력', ...bankTypeList]"
                                                    :select-value="['', 'N', ...bankTypeList]"
                                                    :selected-value.sync="editData.bankType"
                                                    @update:set="handleChangeBankType"
                                                ></select-form>
                                                <input
                                                    v-if="editData.bankType === 'N'"
                                                    type="text"
                                                    placeholder="은행명 입력"
                                                    v-model="editData.bankName"
                                                    style="width: 160px"
                                                />
                                                <input
                                                    type="text"
                                                    placeholder="입금 계좌번호"
                                                    v-model="editData.bankNumber"
                                                    :disabled="!editData.bankName"
                                                />
                                                <input
                                                    type="text"
                                                    placeholder="예금주"
                                                    v-model="editData.bankOwner"
                                                    :disabled="!editData.bankName"
                                                    style="width: 160px"
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            통장 사본
                                            <span class="imp">*</span>
                                        </th>
                                        <th>
                                            <span>{{ editData.bankBookName }}</span>
                                        </th>
                                        <td>
                                            <label for="bank-book-file" class="browse-btn com-btn">
                                                찾아보기
                                                <input id="bank-book-file" type="file" @change="handleChangeBankBook" />
                                            </label>
                                            <button
                                                v-if="!!editData.bankBookUrl || !!editData.bankBookFile"
                                                class="com-btn blue"
                                                @click="showBankbookDlg"
                                            >
                                                미리보기
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="bottom-btn mt-10">
                        <button class="com-btn" @click="handleCancel">취소</button>
                        <button class="com-btn blue" @click="save">{{ selected ? '수정' : '신청' }}</button>
                    </div>
                </div>

                <div v-else class="fitpay-list">
                    <div class="d-flex align-items-center justify-content-between">
                        <p class="tit">정산 계좌 내역</p>
                        <button class="com-btn blue" @click="handleAddNew">핏페이 신청</button>
                    </div>

                    <div class="com-table-content" style="margin-top: 24px">
                        <table class="com-table">
                            <colgroup>
                                <col style="width: 120px" />
                                <col style="width: 160px" />
                                <col style="width: 160px" />
                                <col style="width: 160px" />
                                <col style="width: auto" />
                                <col style="width: auto" />
                                <col style="width: 120px" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>
                                        <button
                                            :class="sortType === 'ASC' ? 'asc' : 'desc'"
                                            @click="(sortType = sortType === 'ASC' ? 'DESC' : 'ASC'), fetchFitpayList()"
                                        >
                                            처리일
                                        </button>
                                    </th>
                                    <th>처리상태</th>
                                    <th>정산 담당자</th>
                                    <th>담당자 연락처</th>
                                    <th>담당자 이메일</th>
                                    <th>정산 계좌</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in fitpayList" :key="index">
                                    <td>{{ item.cf_upd_dt | timestampFilter }}</td>
                                    <td>
                                        <span v-if="item.cf_status === 'P'" class="">미승인</span>
                                        <span v-if="item.cf_status === 'D'" class="">승인완료</span>
                                        <span
                                            role="button"
                                            v-if="item.cf_status === 'R'"
                                            class="link underline"
                                            @click="rejectItem = item"
                                        >
                                            반려
                                        </span>
                                    </td>
                                    <td>{{ item.namee || '' }}</td>
                                    <td>{{ item.cf_contact_tel }}</td>
                                    <td>{{ item.cf_contact_email }}</td>
                                    <td>
                                        <span role="button" class="link" @click="showBankbookDlg($event, item)">
                                            ({{ item.cf_bank_name }}) {{ item.cf_bank_number }}
                                        </span>
                                    </td>
                                    <td>
                                        <button class="com-btn" @click="handleEdit(item)">수정</button>
                                        <button class="com-btn red" @click="handleDelete(item)">철회</button>
                                    </td>
                                </tr>
                                <tr v-if="fitpayList.length === 0">
                                    <td colspan="100">등록된 내용이 없습니다.</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="sort-bottom-area">
                            <select-form
                                :select-data="['10줄보기', '20줄보기', '50줄보기', '100줄보기']"
                                @update:set="(val) => (value = val)"
                                class="float-right"
                            ></select-form>
                        </div>
                        <b-pagination
                            class="mt-10"
                            v-model="pagingInfo.page"
                            :per-page="pagingInfo.limit"
                            :total-rows="pagingInfo.totalItems"
                            align="center"
                            aria-controls="my-table"
                            first-class="first"
                            last-class="last"
                            next-class="next"
                            prev-class="prev"
                            @change="handlerPagenation($event)"
                        ></b-pagination>
                    </div>
                </div>
            </div>
        </form>
        <bankbook-confirm-dlg
            :show="openBankbookDlg && !!defaultImageUrl"
            :imageUrl="defaultImageUrl"
            :downloadName="defaultImageName"
            :close="() => (openBankbookDlg = false)"
        ></bankbook-confirm-dlg>
        <reject-reason-dlg
            :show="!!rejectItem"
            :editable="false"
            :content="rejectItem ? rejectItem.cf_reject_reason : ''"
            :close="() => (rejectItem = null)"
            :confirm="() => (rejectItem = null)"
        ></reject-reason-dlg>
    </div>
</template>

<script>
import api from '../../../assets/js/api';
import { validateEmail, validateFormattedTelNo } from '../../../assets/js/validation';
import LoadingSpinner from '../../../components/LoadingSpinner';
import BankbookConfirmDlg from '../../../components/BankbookConfirmDlg.vue';
import RejectReasonDlg from '../../../components/RejectReasonDlg.vue';
import { Utils } from '../../../assets/js/utils';
import { BANK_TYPES } from '../../../assets/js/common';

export default {
    name: 'SettingCenterFitpay',
    components: { LoadingSpinner, BankbookConfirmDlg, RejectReasonDlg },
    props: ['centerId'],
    computed: {},
    data() {
        return {
            isLoading: false,
            submenus: [
                { name: 'SettingCenterEdit', label: '기본정보' },
                { name: 'SettingCenterProgram', label: '프로그램 가입내역' },
                { name: 'SettingCenterHoliday', label: '휴일설정' },
                { name: 'SettingCenterAccount', label: '정산설정' },
                { name: 'SettingCenterPaymentList', label: '결제내역' },
                { name: 'SettingCenterPaymentMethod', label: '결제수단' },
                { name: 'SettingCenterFitpay', label: '핏페이' }, // TESTING ON PROD
                // { name: 'SettingCenterLecture', label: '교차수강설정' },
            ],
            statusText: {
                P: '승인 요청',
                D: '승인 완료',
                R: '반려',
            },
            staffs: {},
            staffList: [],
            emailTypeValueList: [...this.$emailType],
            bankTypeList: Object.values(BANK_TYPES),
            centerData: {}, // 센터정보
            fitpayList: [], // 핏페이 신청정보
            editData: null, // 핏페이 편집정보
            selected: null, // 선택된 정보
            pagingInfo: {
                page: 1, // 페이지
                limit: 5, // 한 목록에 표출되는 건수
                totalItems: '', // 총 Item 수
                itemCount: '', // 현재 페이지 item 수
                totalPages: '', // 총 페이지 수
                route: '', // 링크 경로 생성시 프리픽스
            },
            sortType: 'DESC',
            defaultImageUrl: '',
            defaultImageName: '',
            openBankbookDlg: false,
            rejectItem: null,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        loadCenterData() {
            if (!this.centerId) return;
            api.get(`/admin/api/center/${this.centerId}`)
                .then((res) => {
                    this.centerData = res.data;
                    let telNo = [];
                    if (this.centerData.telNo.length === 8) {
                        //전화번호가 8글자일경우 적용됨(21.03.17)
                        telNo = this.centerData.telNo.match(/(\d{4})(\d{4})/);
                        telNo = ['', ...telNo];
                    } else if (this.centerData.telNo.indexOf('02') === 0) {
                        telNo = (this.centerData.telNo || '').match(/(\d{2})(\d{3,4})(\d{4})/);
                    } else if (this.centerData.telNo.length === 10) {
                        telNo = (this.centerData.telNo || '').match(/(\d{3})(\d{3})(\d{4})/);
                    } else {
                        telNo = (this.centerData.telNo || '').match(/(\d{3})(\d{4,4})(\d{4})/);
                    }

                    if (telNo) {
                        this.centerData.telNo1 = telNo[1];
                        this.centerData.telNo2 = telNo[2];
                        this.centerData.telNo3 = telNo[3];
                        this.centerData.telNo = telNo;
                    }
                })
                .catch((res) => {
                    this.centerData = {};
                    if (res.response.status != 404) alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                });
        },
        async fetchStaffList() {
            if (Object.keys(this.staffs).length > 0) return;

            const res = await api.get(`/admin/api/center/${this.centerId}/staff/all/list`);
            this.staffList = res.data || [];
            this.staffs = this.staffList.reduce((re, d) => ({ ...re, [d.centerStaffId]: d.name }), {});
        },
        async fetchFitpayList(pageNum) {
            if (this.isLoading) return;

            this.isLoading = true;

            const res = await api.get(`/admin/api/center/fitpay/list/${this.centerId}`, {
                params: {
                    ...this.pagingInfo,
                    page: pageNum || this.pagingInfo.page,
                    sortTYpe: this.sortType,
                },
            });

            this.isLoading = false;
            if (res.data) {
                this.fitpayList = res.data.items || [];

                const metaData = res.data.meta;
                this.pagingInfo = {
                    ...this.pagingInfo,
                    page: metaData.currentPage,
                    totalItems: metaData.totalItems, // 총 Item 수
                    itemCount: metaData.itemCount, // 현재 페이지 item 수
                    totalPages: metaData.totalPages, // 총 페이지 수
                };
            }
        },
        init() {
            this.loadCenterData();
            this.fetchFitpayList(1);
        },
        handleAddNew() {
            this.fetchStaffList();

            this.selected = null;
            this.defaultImageUrl = '';
            this.defaultImageName = '';
            this.editData = {
                centerStaffId: '',
                telNo1: '',
                telNo2: '',
                telNo3: '',
                email1: '',
                email2: '',
                emailType: '',
                bankType: '',
                bankName: '',
                bankNumber: '',
                bankOwner: '',
                bankBookName: '',
                bankBookUrl: '',
                bankBookFile: null,
            };
        },
        handleEdit(item) {
            api.get(`/admin/api/center/fitpay/${item.cf_id}`);
            this.fetchStaffList();
            this.selected = { ...item };
            this.defaultImageUrl = item.cf_bank_book_url;
            this.defaultImageName = item.cf_bank_book_name;

            const contactTel = item.cf_contact_tel.split('-');
            const contactEmail = item.cf_contact_email.split('@');

            this.editData = {
                centerStaffId: String(item.cf_center_staff_id),
                telNo1: contactTel[0] || '',
                telNo2: contactTel[1] || '',
                telNo3: contactTel[2] || '',
                email1: contactEmail[0] || '',
                email2: contactEmail[1] || '',
                emailType: this.emailTypeValueList.indexOf(contactEmail[1]) > -1 ? contactEmail[1] : '',
                bankType: this.bankTypeList.indexOf(item.cf_bank_name) > -1 ? item.cf_bank_name : 'N',
                bankName: item.cf_bank_name,
                bankNumber: item.cf_bank_number,
                bankOwner: item.cf_bank_owner,
                bankBookName: item.cf_bank_book_name,
                bankBookUrl: item.cf_bank_book_url,
                bankBookFile: null,
            };
        },
        onChangeEmail(type) {
            this.editData.emailType = type;
            if (type) {
                this.editData.email2 = type;
            }
        },
        handleCancel() {
            this.selected = null;
            this.editData = null;
            this.defaultImageUrl = '';
            this.defaultImageName = '';
        },

        validateFormdata() {
            const { telNo1, telNo2, telNo3, email1, email2, emailType, bankType, ...data } = this.editData;
            const contactTel = `${(telNo1 || '').trim()}-${(telNo2 || '').trim()}-${(telNo3 || '').trim()}`;
            const contactEmail = `${(email1 || '').trim()}@${(email2 || '').trim()}`;

            let errors = [];
            if (!data.centerStaffId) errors.push({ key: 'centerStaffId', message: '정산 담당자를 선택해주세요.' });
            if (!validateFormattedTelNo(contactTel))
                errors.push({ key: 'contactTel', message: '담당자 연락처를 다시 입력해주세요.' });
            if (!validateEmail(contactEmail))
                errors.push({ key: 'contactEmail', message: '담당자 이메일을 다시 입력해주세요.' });
            if (!data.bankName) errors.push({ key: 'bankName', message: '은행명을 입력해주세요.' });
            if (!data.bankNumber) errors.push({ key: 'bankNumber', message: '입금 계좌번호를 입력해주세요.' });
            if (!data.bankOwner) errors.push({ key: 'bankOwner', message: '예금주를 입력해주세요.' });
            if (!data.bankBookUrl && !data.bankBookFile)
                errors.push({ key: 'bankBookUrl', message: '통장사본을 첨부해주세요.' });

            if (errors.length) {
                alert(errors[0].message);
                return null;
            }

            return {
                ...data,
                contactTel,
                contactEmail,
            };
        },
        async save(e) {
            e.stopPropagation();
            e.preventDefault();

            const formdata = this.validateFormdata();
            if (!formdata || this.isLoading) return;
            if (!confirm(this.selected ? '핏페이 사용 신청 수정하시겠습니까?' : '핏페이 사용 신청 접수하시겠습니까?'))
                return;

            this.isLoading = true;

            let res;
            if (this.selected) {
                res = await api.put(`/admin/api/center/fitpay/${this.selected.cf_id}`, { ...formdata });
            } else {
                res = await api.post(`/admin/api/center/fitpay/create/${this.centerId}`, { ...formdata });
            }

            this.isLoading = false;

            if (res.status === 200) {
                alert(this.selected ? '핏페이 사용 신청 수정되었습니다.' : '핏페이 사용 신청 접수되었습니다.');
                this.selected = null;
                this.editData = null;
                this.fetchFitpayList(1);
            } else {
                alert('핏페이 사용 신청시 오류가 발생하였습니다.');
            }
        },
        async handleDelete(item) {
            if (!confirm('핏페이 사용 신청을 철회하시겠습니까?')) return;
            if (!item || this.isLoading) return;

            this.isLoading = true;
            const res = await api.delete(`/admin/api/center/fitpay/${item.cf_id}`);
            this.isLoading = false;

            if (res.status === 200) {
                this.fetchFitpayList();
            } else {
                alert('핏페이 사용 신청을 철회시 오류가 발생하였습니다.');
            }
        },
        handleChangeBankBook(e) {
            if (!e.target.files.length) return;

            const file = e.target.files[0];
            const filename = file.name;
            this.editData.bankBookName = filename;
            this.editData.bankBookFile = { filename, mimetype: file.type };
            this.createBase64Image(file);
        },

        // Base64 Image 생성
        createBase64Image(fileObj) {
            const reader = new FileReader();
            reader.onload = (e) => {
                this.defaultImageUrl = e.target.result;
                this.defaultImageName = fileObj.filename;
                this.editData.bankBookFile.base64data = this.defaultImageUrl.split(',')[1];
            };
            reader.readAsDataURL(fileObj);
        },

        handleChangeStaff(id) {
            const sel = this.staffList.find((s) => s.centerStaffId === Number(id));
            if (!sel) return;

            const phone = Utils.splitContactNumber(sel.phone);
            const email = sel.email.split('@');

            this.editData = {
                ...this.editData,
                centerStaffId: id,
                telNo1: phone[0],
                telNo2: phone[1],
                telNo3: phone[2],
                email1: email[0],
                email2: email[1],
                emailType: this.emailTypeValueList.indexOf(email[1]) > -1 ? email[1] : '',
            };
        },

        handleChangeBankType(type) {
            this.editData = {
                ...this.editData,
                bankType: type,
                bankName: type !== 'N' ? type : '',
            };
        },
        showBankbookDlg(e, item) {
            console.log(this.editData, e);
            e.stopPropagation();
            e.preventDefault();

            if (item) {
                this.defaultImageUrl = item.cf_bank_book_url;
                this.defaultImageName = item.cf_bank_book_name;
            } else {
                if (this.editData.bankBookFile) {
                    this.defaultImageName = this.editData.bankBookFile.filename;
                } else {
                    this.defaultImageUrl = this.editData.bankBookUrl;
                    this.defaultImageName = this.editData.bankBookName;
                }
            }

            this.openBankbookDlg = true;
        },
    },
};
</script>
<style lang="scss">
.center-fitpay {
    padding-top: 50px;
    color: #707070;

    .fitpay-starter {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .desc {
            width: 100%;
            background-color: #0078f426;
            padding: 32px;
            font-size: 18px;
            line-height: 28px;
            font-weight: 500;
            color: #0078f4;
            text-align: center;
            margin-bottom: 96px;
        }
        .avatar {
            width: 162px;
            height: 64px;
            background: url(/img/icons/logo_fitpay.svg) no-repeat;
            background-size: contain;
            margin-bottom: 64px;
        }
        .com-btn {
            background-color: #0078f4;
            width: 240px;
        }
    }

    .fitpay-detail {
        .tit {
            background-color: #f1f5f7;
            height: 60px;
            padding: 16px 22px;
            font-size: 18px;
            line-height: 26px;
            margin-bottom: 32px;
        }

        .guide {
            display: flex;
            align-items: baseline;
            gap: 16px;
            background-color: #00c7e50d;
            padding: 16px;
            .g_tit {
                color: #00c7e5;
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 4px;
            }
        }
    }

    .fitpay-list {
        .tit {
            font-size: 20px;
            color: #535353;
        }
        .link {
            color: #4780fd;
            text-decoration: underline;
        }
    }
}
</style>
